var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { transformObject } from '../functions/transformObject';
export var createTypographyVariants = function (options) {
    return Object.entries(options).map(function (_a) {
        var variant = _a[0], style = _a[1];
        var mobileStyle = transformObject(style, {
            values: function (value) { return (typeof value === 'object') ? value[0] : value; },
        });
        var desktopStyle = transformObject(style, {
            values: function (value) { return (typeof value === 'object') ? value[1] : value; },
        });
        return {
            props: {
                variant: variant,
            },
            style: function (_a) {
                var _b;
                var theme = _a.theme;
                return (__assign(__assign({}, mobileStyle), (_b = {}, _b[theme.breakpoints.up('md')] = __assign({}, desktopStyle), _b)));
            },
        };
    });
};
